import { render } from "./MobileNavigation.vue?vue&type=template&id=d284d226"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__